import { getItemFromLocalStorage, setItemFromLocalStorage } from 'reactApp/appHelpers/localstorageHelpers';
import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderDuplicatesRemoveLimitModal = () => {
    openPopupHelper({
        popupName: popupNames.DUPLICATES_REMOVE_LIMIT_MODAL,
    });
};

const LOCAL_STORAGE_KEY = 'duplicates-removed-groups' as const;

export const getDuplicatesRemovedGroupsCount = () => getItemFromLocalStorage(LOCAL_STORAGE_KEY);

export const setDuplicatesRemovedGroupsCount = (count: number) => setItemFromLocalStorage(LOCAL_STORAGE_KEY, count);
